const FULLSTORY_URL = import.meta.env.VITE_FULLSTORY_URL

export const initializeFullstory = () => {
  const id = 'fullstory'
  if (!document.getElementById(id)) {
    const script = document.createElement('script')
    script.async = true
    script.type = 'text/javascript'
    script.src = FULLSTORY_URL
    script.id = id

    const firstScript = document.getElementsByTagName("script")[0]
    if (firstScript) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }
    console.info('Fullstory initialized')
  }
}